// Package-local loading spinner — visually the platform's loading indicator.
// Uses the shared `spin` keyframes (globals.css + appTheme.ts APP_BASE_CSS, so
// the standalone runtime client injects them too) via the same Loader2 idiom
// used elsewhere in the package (e.g. EmbedCapturePreview).

import { Loader2 } from 'lucide-react'

interface SpinnerProps {
  centered?: boolean
  label?: string
}

export default function Spinner({ centered = false, label }: SpinnerProps) {
  const spinner = (
    <Loader2
      size={20}
      role="status"
      aria-label={label || 'Loading'}
      style={{ animation: 'spin 1s linear infinite', color: 'var(--color-accent)' }}
    />
  )

  if (centered) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3rem',
          gap: '0.75rem',
        }}
      >
        {spinner}
        {label && (
          <span
            style={{
              fontSize: '0.875rem',
              color: 'var(--color-text-secondary)',
            }}
          >
            {label}
          </span>
        )}
      </div>
    )
  }

  return spinner
}
